"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const common_styled_components_1 = require("../../common-styled-components");
const useFetch_1 = __importDefault(require("../../../hooks/useFetch"));
const apiUtils_1 = require("../../../util/apiUtils");
const TransactionTable_1 = require("../common/tables/TransactionTable");
const YearContext_1 = require("../../../contexts/YearContext");
const react_1 = require("react");
const TransactionStatistics_1 = require("../common/TransactionStatistics");
exports.default = () => {
    const { selectedYear } = (0, YearContext_1.useYear)();
    const [transactions, _setUrl, _setBody, refresh] = (0, useFetch_1.default)("admin/transactions.json", undefined, true);
    (0, react_1.useEffect)(() => {
        _setBody(JSON.stringify({
            year: selectedYear,
        }));
    }, [selectedYear]);
    if (transactions.status !== apiUtils_1.LoaderStatus.Success) {
        return (0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { children: "Loading\u2026" });
    }
    // log([
    //   {
    //     label: "Transactions",
    //     content: transactions.data,
    //   },
    // ]);
    return ((0, jsx_runtime_1.jsxs)(common_styled_components_1.PageContent, { align: "left", children: [(0, jsx_runtime_1.jsx)(TransactionStatistics_1.TransactionStatistics, { transactions: transactions.data, year: selectedYear }), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SectionTitle, { children: "Compliance transactions" }), (0, jsx_runtime_1.jsx)(TransactionTable_1.TransactionTable, { transactions: transactions.data, complianceYear: 0, refresh: refresh, isInAdminTools: true })] }) })] }));
};
